import * as BABYLON from "babylonjs";
import * as _ from "lodash";
import { Signal } from "../core/signal";
import { Anchor } from "./anchor";

export class AnchorManager {
    private _camTransform: BABYLON.Matrix;
    private _viewport: BABYLON.Viewport;

    anchors: Anchor[] = [];
    anchorUpdated = new Signal<Anchor>();

    addAnchor(anchor: Anchor) {
        this.anchors.push(anchor);
        this.updateAnchor(anchor);
    }

    removeAnchor(anchor: Anchor) {
        _.pull(this.anchors, anchor);
    }

    updateAnchors(scene: BABYLON.Scene) {
        let cam = scene.activeCamera;
        this._camTransform = cam.getViewMatrix().multiply(cam.getProjectionMatrix());
        this._viewport = cam.viewport.toGlobal(scene.getEngine().getRenderWidth(), scene.getEngine().getRenderHeight());
        this.anchors.forEach(it => this.updateAnchor(it));
    }

    private updateAnchor(anchor: Anchor) {
        if (this._camTransform && this._viewport) {
            anchor.update(this._camTransform, this._viewport);
            this.anchorUpdated.emit(anchor);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/ui/anchorManager.ts